/**
 * login模块接口列表
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const login = {
  // 登录
    adminLogin (data) {
        return axios.post(`${base.baseURL}/login/admin?userName=${data.userName}&password=${data.password}`);
    },

}
export default login;



// WEBPACK FOOTER //
// ./src/network/login.js